export class ChangePassword {
  public currentPassword;
  public password;
  public passwordConfirmation;
}
